import { Component } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
@Component({
  selector: 'app-custom-mat-paginator-intl',
  templateUrl: './custom-mat-paginator-intl.component.html',
  styleUrl: './custom-mat-paginator-intl.component.scss',
})
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return '0 sur ' + length + ' Résultats';
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `De ${startIndex + 1} à ${
      startIndex + pageSize <= length ? startIndex + pageSize : length
    } - ${length} Résultats`;
  };
}
